import React, { useState, useEffect } from 'react';
import MarketplaceCard from './MarketplaceCard';

const RecentlyViewed = () => {
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  useEffect(() => {
    try {
      const viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
      setRecentlyViewed(viewed);
    } catch (e) {
      console.error(e);
    }
  }, []);

  if (recentlyViewed.length === 0) {
    return null;
  }

  return (
    <section className="bg-surface-container-lowest/80 py-12 border-y border-white/5 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-primary/5 rounded-full blur-[100px] -z-10 pointer-events-none"></div>
      <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
        <div className="text-center mb-8">
          <h2 className="font-headline-sm text-headline-sm text-silver-text mb-2">
            Recently <span className="text-primary">Viewed</span>
          </h2>
          <p className="font-label-md text-label-md text-on-surface-variant">
            Continue where you left off.
          </p>
        </div>
        <div className="flex justify-start gap-4 overflow-x-auto pb-4 snap-x">
          {recentlyViewed.map(product => (
            <div key={product.id} className="w-[260px] flex-shrink-0 snap-center transform scale-[0.9] origin-top-left">
              <MarketplaceCard product={product} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
